const scale = 3;

const frameWidth = 1125 / scale;
const frameHeight = 2436 / scale;
const frameDifferenceTop = 110;
const frameDifferenceBottom = 35;

const stageWidth = frameWidth;
const stageHeight = frameHeight - (frameDifferenceTop + frameDifferenceBottom);

const playerWidth = 100;
const playerHeight = 90;

const flowerWidth = 80;
const flowerHeight = 80;

const floorTop = 200;

const bottomLimit = stageHeight - playerHeight;
const hitAreaTop = stageHeight - playerHeight - 200;
const hitAreaBottom = hitAreaTop + 50;

const firstPowerDownAreaTop = 200;
const secondPowerDownAreaTop = 230;

const railsSpriteWidth = 390;
const railsSpriteHeigh = 600;

const layout = {
  SCALE: scale,

  FRAME_WIDTH: frameWidth,
  FRAME_HEIGHT: frameHeight,
  FRAME_DIFFERENCE_TOP: frameDifferenceTop,
  FRAME_DIFFERENCE_BOTTOM: frameDifferenceBottom,

  STAGE_WIDTH: stageWidth,
  STAGE_HEIGHT: stageHeight,

  PLAYER_WIDTH: playerWidth,
  PLAYER_HEIGHT: playerHeight,

  FLOWER_WIDTH: flowerWidth,
  FLOWER_HEIGHT: flowerHeight,

  FLOOR_TOP: floorTop,

  BOTTOM_LIMIT: bottomLimit,
  HIT_AREA_TOP: hitAreaTop,
  HIT_AREA_BOTTOM: hitAreaBottom,

  FIRST_POWER_DONW_TOP: firstPowerDownAreaTop,
  SECOND_POWER_DONW_TOP: secondPowerDownAreaTop,

  RAILS_SPRITE_WIDTH: railsSpriteWidth,
  RAILS_SPRITE_HEIGHT: railsSpriteHeigh,
};

export default layout;
